export default __webpack_public_path__ + "static/media/9.24bd9cf1.jpg";